import React from 'react';
import Select from 'react-select/async';
import { flatten } from 'lodash';

const SearchableRestrictedProviderSelect = ({
  label, disabled, clearable, searchable, name, value, options,
  fetchAsyncOptions, onChange, className, placeholder,
  error, errorMessages, noOptionsMessage, getList
}) => {
  const asyncOptions = async (inputValue, callback) => {
     const results = await fetchAsyncOptions(inputValue);
    if(results && results.length > 0){
      callback(results);
    }else{
      let data =  await getList(inputValue);
      callback(data);
    }
  };

  return (
    <div className={className}>
      <label>{label}</label>
      <Select
        noOptionsMessage={() => (
        <div>{noOptionsMessage}</div>
        )}
        isClearable={clearable}
        isDisabled={disabled}
        isSearchable={searchable}
        placeholder={placeholder}
        name={name}
        value={value}
        defaultOptions={options}
        loadOptions={asyncOptions}
        onChange={onChange}
        styles={{
          control: (base) => ({
            ...base,
            borderColor: error ? '#f44336' : base.borderColor,
          }),
          menu: (base) => ({
            ...base,
            zIndex: '999',
          }),
          menuList: (base) => ({
            ...base,
            zIndex: '999',
          }),
        }}
      />
      {error && (
        <label style={{ color: '#f44336', margin: '8px 12px 0', fontSize: '0.75em' }}>{flatten([errorMessages]).join(', ')}</label>
      )}
    </div>
  );
};

export default SearchableRestrictedProviderSelect;
